<h2 mat-dialog-title>Add Ad-Hoc Participants</h2>

<mat-dialog-content>
  <p class="class-name-label">{{ data.className }}</p>

  <!-- Generation Controls -->
  <div class="generate-row">
    <mat-form-field appearance="outline" class="prefix-field">
      <mat-label>Prefix</mat-label>
      <input
        matInput
        [formControl]="prefixCtrl"
        (input)="onPrefixChange()"
        placeholder="adhoc_user"
        autocomplete="off"
        [matAutocomplete]="prefixAuto"
      />
      <mat-hint *ngIf="prefixHint">{{ prefixHint }}</mat-hint>
      <mat-error *ngIf="prefixCtrl.hasError('pattern') && !prefixCtrl.hasError('minLetters')">
        Must start and end with a letter (a–z); underscores only in the middle
      </mat-error>
      <mat-error *ngIf="prefixCtrl.hasError('minLetters')">
        Minimum 3 letters (underscores don’t count)
      </mat-error>
      <button matSuffix mat-icon-button type="button" class="prefix-info-btn"
        [matTooltip]="prefixRulesTooltip"
        matTooltipClass="prefix-rules-tooltip">
        <mat-icon>info_outline</mat-icon>
      </button>
      <mat-autocomplete #prefixAuto="matAutocomplete" (optionSelected)="onPrefixChange()">
        <mat-option *ngFor="let opt of filteredPrefixes" [value]="opt.prefix">
          {{ opt.prefix }}
          <small class="prefix-count-hint">({{ opt.currentCount }} existing)</small>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" class="count-field">
      <mat-label>Count</mat-label>
      <input matInput type="number" [formControl]="countCtrl" min="1" [attr.max]="effectiveMaxCount" />
      <mat-hint *ngIf="capacityHint">{{ capacityHint }}</mat-hint>
      <mat-error *ngIf="countCtrl.hasError('max')">
        Maximum {{ effectiveMaxCount }} (class capacity limit)
      </mat-error>
    </mat-form-field>

    <button
      mat-raised-button
      color="primary"
      class="generate-btn"
      [disabled]="!canGenerate"
      (click)="generateAndAdd()"
    >
      <mat-spinner *ngIf="isGenerating" diameter="18" class="btn-spinner"></mat-spinner>
      <span *ngIf="!isGenerating">Generate &amp; Add</span>
      <span *ngIf="isGenerating && !hasRows">Creating…</span>
      <span *ngIf="isGenerating && hasRows">Adding to class…</span>
    </button>
  </div>

  <!-- Stripped-chars warning (shown immediately on input, not tied to form validity) -->
  <!-- Preview Table (read-only; visible while save is in-flight then dialog auto-closes) -->
  <div class="table-container" *ngIf="hasRows">
    <table mat-table [dataSource]="rows" class="adhoc-table">

      <!-- Seq No Column -->
      <ng-container matColumnDef="seqNo">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let row">{{ row.seqNo }}</td>
      </ng-container>

      <!-- Login ID Column -->
      <ng-container matColumnDef="loginId">
        <th mat-header-cell *matHeaderCellDef>Login ID</th>
        <td mat-cell *matCellDef="let row">{{ row.loginId }}</td>
      </ng-container>

      <!-- Password Column -->
      <ng-container matColumnDef="password">
        <th mat-header-cell *matHeaderCellDef>Password</th>
        <td mat-cell *matCellDef="let row">{{ row.password }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['seqNo','loginId','password']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['seqNo','loginId','password']"></tr>
    </table>
  </div>

  <div class="empty-generate" *ngIf="!hasRows && !isGenerating">
    <mat-icon>group_add</mat-icon>
    <span>Configure prefix &amp; count, then click Generate &amp; Add.</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="isGenerating">Cancel</button>
</mat-dialog-actions>
